import {Component} from 'react';
import axios from "axios"
import Nav from "./Nav";
import Swal from "sweetalert2";
import myconfig from "../myconfig";
import $ from 'jquery';
import { Modal,Button } from 'react-bootstrap';

let source = axios.CancelToken.source();

class Stoppage extends Component {
    constructor() {
        super();
        this.state = {
            menu: 'g-sidenav-show bg-gray-100',
            objs:[],
            objsload:false,
            //modal
            moreshow:false,
            vehicles:[],
            srangs:[],
            srangsfilter:[],
            plateno:'',
        }
    }

    componentDidMount() {
        let baseurl = myconfig.getactivefollowup;
        let redirecttologin = myconfig.redirecttologin;
        let sid = new URLSearchParams(this.props.location.search).get("sid");
        let user = new URLSearchParams(this.props.location.search).get("user");
        axios.post(baseurl, {
            "sid": sid,
            "user": user,
        }, {cancelToken: source.token}).then(res => {
            console.log(res.data)
            if (res.data.auth == false) {
                /*  window.localStorage.setItem("fas_sid", null);
                  window.localStorage.setItem("fas_username", null);
                  window.localStorage.setItem("fas_name", null);
                  var win = window.open(redirecttologin, "_self");*/
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    objs:res.data,
                    objsload:true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });

    }

    hidemore = () => {
        this.setState({
            moreshow: false,
        })
    }
    modalmore=()=> {
        let count=0;
        let datas=this.state.srangsfilter.map(value => {
            count=count+1;
            return (<tr>
                    <td>{count}</td>
                    <td>{value.loc}</td>
                    <td>{value.st}</td>
                    <td>{value.ed}</td>
                    <td>{value.allowed}</td>
                    <td>{value.notallowed}</td>
                </tr>
            )
        })
        return (<Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={this.state.moreshow}
                onHide={this.hidemore}>
                <Modal.Header><h4>Vehicle Stoppage</h4>
                    <small>({this.state.plateno})</small></Modal.Header>
                <Modal.Body>
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h3 className="card-title">Stoppage Report</h3>
                                            <div className="card-tools">
                                            </div>
                                        </div>
                                        {/* /.card-header */}
                                        <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                            <table className="table table-head-fixed text-nowrap">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Location </th>
                                                    <th>Start Time</th>
                                                    <th>End Time</th>
                                                    <th>Allowed Stoppage</th>
                                                    <th>Not-allowed Stoppage</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {datas}
                                                </tbody>
                                            </table>
                                        </div>
                                        {/* /.card-body */}
                                    </div>
                                    {/* /.card */}
                                </div>
                            </div>
                        </div>
                    </section>
                </Modal.Body>
            </Modal>
        )
    }
    btnmore = (event,plateno) => {
        event.preventDefault();
        let filter=this.state.objs.srangs.filter(function (value) {
            return value.plateno==plateno
        })
        console.log(filter)
        this.setState({
            moreshow: true,
            srangsfilter:filter,
            plateno:plateno,
        })
    }


    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    menuhidden = (event) => {
        event.preventDefault();
        if (this.state.menu == "g-sidenav-show bg-gray-100")
            this.setState({
                menu: "g-sidenav-hidden bg-gray-100"
            })
        else
            this.setState({
                menu: "g-sidenav-show bg-gray-100"
            })
    }
    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    vehicledata = () => {
        let retdata = null;
        if (this.state.objsload) {
            let count = 0;
            retdata = this.state.objs.vehicles.map(value => {
                count = count + 1
                return (<tr>
                    <td>{count}</td>
                    <td>
                       <a href="#"
                                onClick={(event => this.btnmore(event,value.plateno))}>More
                        </a>
                    </td>
                    <td>{value.plateno}</td>
                    <td>{value.status}</td>
                    <td>{value.st}</td>
                    <td>{value.ed}</td>
                    <td>{value.total}</td>
                    <td>{value.allowed}</td>
                    <td>{value.notallowed}</td>
                </tr>)
            })
        }
        return (<>{retdata}</>)
    }
    render() {
        return (
            <>
                <>
                    <Nav type="rfollowup"/>
                    <div className="content-wrapper">
                        <div className="content-header">
                            <div className="container-fluid">
                                <div className="row mb-2">
                                    <div className="col-sm-6">
                                        <h1 className="m-0">Stoppage Managment</h1>
                                    </div>
                                    <div className="col-sm-6">
                                        <ol className="breadcrumb float-sm-right">
                                            <li className="breadcrumb-item"><a href="#">Stoppage</a></li>
                                            <li className="breadcrumb-item active"></li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-header">
                                                <h3 className="card-title">Stoppage Report</h3>
                                                <div className="card-tools">
                                                </div>
                                            </div>
                                            {/* /.card-header */}
                                            <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                                <table className="table table-head-fixed text-nowrap">
                                                    <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Action</th>
                                                        <th>Truck</th>
                                                        <th>Status</th>
                                                        <th>Start Time</th>
                                                        <th>End Time</th>
                                                        <th>Total Stoppage</th>
                                                        <th>Allowed Stoppage</th>
                                                        <th>Not-allowed Stoppage</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {this.vehicledata()}
                                                    </tbody>
                                                </table>
                                            </div>
                                            {/* /.card-body */}
                                        </div>
                                        {/* /.card */}
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                    {this.modalmore()}
                </>
            </>
        )
    }
}

export default Stoppage;
